module.exports = __webpack_public_path__ + "img/Cover_HW_18.d7fad490.jpg";